class PageSelector extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['toggle', 'body']
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(this.els.toggle.element, 'click', this.toggle.bind(this))
  }

  toggle () {
    this.expanded = !this.expanded
  }

  /** @returns {boolean} */
  get expanded () {
    return this.hasAttribute('expanded')
  }

  set expanded (expanded) {
    this.els.toggle.element.setAttribute('aria-expanded', expanded)

    this.toggleAttribute('expanded', expanded)
  }
}

if (!window.customElements.get('page-selector')) {
  window.customElements.define('page-selector', PageSelector)
}
